import gql from 'graphql-tag';

import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';

export const USERS_LIST_QUERY = gql`
	query Users($first: Int, $after: String) {
		users(first: $first, after: $after) {
			nodes {
				userId
				username
				email
				firstName
				lastName
				isActive
				createdAt
				userRoles {
					role {
						name
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const USER_LIST_ITEM_QUERY = gql`
	query UserListItem($id: Ulid!) {
		user(id: $id) {
			userId
			username
			email
			firstName
			lastName
			isActive
			createdAt
			userRoles {
				roleId
				role {
					roleId
					name
					description
				}
			}
		}
	}
`;

export const USER_QUERY = gql`
	query User($id: Ulid!) {
		user(id: $id) {
			userId
			username
			email
			firstName
			lastName
			isActive
			createdAt
			userRoles {
				roleId
				role {
					roleId
					name
					description
				}
			}
			facilities {
				facilityId
				name
			}
			userPreferences {
				userPreferenceId
				settingsJson
			}
		}
	}
`;

listResourceQueryDefinitions['users'] = {
	document: USERS_LIST_QUERY,
	dataPath: 'users.nodes'
};

viewResourceQueryDefinitions['users'] = {
	document: USER_QUERY,
	dataPath: 'user'
};
